import { load, Bot } from "../bot-loaders";
import {DonutChartItem} from 'react-charts'

interface ChartResult {
    chartData: {
        status: string
        n: number
      }[]
}

export function getLabel(k:string){
    switch(k){
        case "interaction": return "Interação"
        case "read": return "Lidos"
        case "sent": return "Enviados"
        case "delivered": return "Entregues"
        default: return "Outros";
    }
}

export function getStyle(s:string){
    switch(s){
        case "interaction": return "color5"
        case "read": return "color10";
        case "sent": return "color15";
        case "delivered": return "color12";
        default: return "color17";
    }
}

export async function loadBotMessageChartData(bot:Bot, today = false):Promise<DonutChartItem[]>{
    const todayPrefix = today ? 'today-' : '';
    var list:ChartResult  = await load(`bots/${bot.id}/${todayPrefix}messages-chart`, null, bot.token, true);
    return list.chartData.map((a, i) => {
        return {
            label: getLabel(a.status),
            style: getStyle(a.status),
            value: a.n
        }
    });
}